import { createContext, useContext } from "react";
import type { User } from "oidc-client-ts";

export type AuthStatus =
  | "initializing"
  | "unauthenticated"
  | "authenticated"
  | "renewing"
  | "error";

export interface AuthContextValue {
  user: User | null;
  status: AuthStatus;
  error: Error | null;
  login: (returnUrl?: string) => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
